// components/FieldTemplateForm/FieldTemplateForm.tsx

import React, { SetStateAction } from 'react'
import classes from './FieldTemplateForm.module.scss'
import { useFieldTemplateForm } from './useFieldTemplateForm'
import { CategoryFieldTemplateInterface } from '../../types/interfaces'
import { Button } from '../button/Button'
import { FieldTemplateItem } from './FieldTemplateItem'

type Props<T> = {
  topData: T & { fields: CategoryFieldTemplateInterface[] }
  setTopData: (data: T & { fields: CategoryFieldTemplateInterface[] }) => void
  setDisabled: React.Dispatch<SetStateAction<boolean>>
  disabled: boolean
}

export const FieldTemplateForm = <T,>({ topData, setTopData, setDisabled, disabled }: Props<T>) => {
  const { data, addItem, removeItem, itemUp, itemDown, handleFieldChange, itemPattern } =
    useFieldTemplateForm(
      topData,
      setTopData as React.Dispatch<React.SetStateAction<typeof topData>>,
      setDisabled,
    )

  return (
    <div className={classes.container}>
      {!data.length && (
        <div className={classes.button}>
          <Button
            small
            text="Добавить поле"
            onClick={() => {
              addItem({ ...itemPattern, id: Date.now() })
            }}
          />
        </div>
      )}
      {data.map((el, index) => (
        <FieldTemplateItem
          key={el.id}
          index={index}
          el={el}
          length={data.length}
          addItem={addItem}
          removeItem={removeItem}
          itemUp={itemUp}
          itemDown={itemDown}
          onChange={handleFieldChange}
        />
      ))}
    </div>
  )
}
